function onCheckoutAuthenticating(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onCheckoutAuthenticating', e);
  }

  // Do something stub onCheckoutAuthenticating

  return;
}

export default onCheckoutAuthenticating;
